
interface SeparatorProps {
	color: string;
}

const Separator: React.FC<SeparatorProps> = ({ color }) => {
	return (
		<svg width="6" height="11" viewBox="0 0 6 11" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M1 10L5 5.75L1 1.5" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
		</svg>
	);
};

export default Separator;
